import styled, { css } from 'styled-components';
import { FlexContainer as FlexContainer_ } from '@taxdown/piccolo-web';

export const FlexContainer = styled(FlexContainer_)`
  padding: 1rem;
  border-bottom: 1px solid ${({ theme: { colors } }) => colors.blue_5};
  cursor: pointer;
  &:hover {
    background: ${({ theme: { colors } }) => colors.green_6};
  }
  ${({ isActive, theme: { colors } }) =>
    isActive &&
    css`
      background: ${colors.green_6};
    `};
`;

export const LinksContainer = styled.div`
  border-top: 1px solid ${({ theme: { colors } }) => colors.blue_5};
`;
